import { useEffect, useState } from 'react';

type State<T> = { request: () => Promise<T>; data: T | null; error: string; loading: boolean };

export function useRegistryData<T>(request: () => Promise<T>) {
  const [state, setState] = useState<State<T> | null>(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let current = true;
    const timer = setTimeout(() => {
      void request()
        .then((data) => {
          if (current) setState({ request, data, error: '', loading: false });
        })
        .catch((caught: unknown) => {
          if (current)
            setState((previous) => ({
              request,
              data: previous?.request === request ? previous.data : null,
              error: caught instanceof Error ? caught.message : 'Не удалось загрузить ресурсы',
              loading: false,
            }));
        });
    }, 200);
    return () => {
      current = false;
      clearTimeout(timer);
    };
  }, [request, attempt]);
  function refresh() {
    setState((previous) => ({
      request,
      data: previous?.request === request ? previous.data : null,
      error: '',
      loading: true,
    }));
    setAttempt((value) => value + 1);
  }
  const active = state?.request === request ? state : { data: null, error: '', loading: true };
  return { ...active, refresh };
}
